import { Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-error-required',
  templateUrl: './error-required.html',
  styleUrl: './error-required.scss',
})
export class ErrorRequiredComponent {
  errorMsg = 'Obavezno polje';

  formCtrl = input.required<FormControl<any>>();

  shouldDisplayRequiredError(): boolean {
    return shouldDisplayRequiredError(this.formCtrl());
  }
}

export function shouldDisplayRequiredError(
  formCtrl: FormControl<any>,
): boolean {
  return (
    (formCtrl.errors?.['required'] && (formCtrl.dirty || formCtrl.touched)) ||
    (formCtrl.errors?.['invalidGuid'] && (formCtrl.dirty || formCtrl.touched))
  );
}
